module.exports = __webpack_public_path__ + "img/contributions5Off.1bcbbe3d.svg";